import { render, staticRenderFns } from "./ModulesLoader.vue?vue&type=template&id=64d2e25b&scoped=true"
import script from "./ModulesLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModulesLoader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ModulesLoader.vue?vue&type=style&index=0&id=64d2e25b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d2e25b",
  null
  
)

export default component.exports